import { EditorState } from '@candulabs/craft';

import { normalizeRTE } from 'craft/rte/normalization';

import { normalizeCollection } from './normalizeCollection';
import { normalizeCss } from './normalizeCss';

export const normalizeNodes = (state: EditorState) => {
  normalizeCss(state);
  normalizeRTE(state);
  normalizeCollection(state);
};
